import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import {
    AbstractControl,
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { MessageModalComponent } from "@niceltd/cxone-components/modal";
import { DialogService } from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { CVLocalizationService } from "src/app/reusables/services/cv-localization.service";
import {
    ContactGroupPayload,
    DataFlowSubFields,
    DefaultConfigurationData,
    ETLExcludeIf,
    ETLGroup,
    ETLReportingSetDropdownOptions,
    ETLReportingSetFieldTypes,
    ETLReportingSetFieldTypesId,
    ETLReportingSetFlowbuilderModules,
    ETLReportingSetJoinedFeedsList,
    ETLReportingSetReturnTypes,
    ETLReportingSetSimpleFieldReturnOptions,
    EmployeeGroupPayload,
    HierarchyGroupName
} from "../../cxone-etl-reporting-set.model";
import { CxoneReportingSetConditionalFieldComponent } from "../field-types/cxone-reporting-set-conditional-field/cxone-reporting-set-conditional-field.component";
import { CxoneReportingSetComplexNumericFieldComponent } from "../field-types/complex-numeric-field/complex-numeric-field.component";
@Component({
    selector: "cv-cxone-reporting-set-data-field",
    templateUrl: "./cxone-reporting-set-data-field.component.html",
    styleUrls: ["./cxone-reporting-set-data-field.component.scss"],
})
export class CxoneReportingSetDataFieldComponent implements OnInit, OnChanges {
    @Input() parentForm: FormGroup;
    @Output() back = new EventEmitter<void>();
    @Input() hideFields = false;
    @Output() buildedForm = new EventEmitter<void>();
    @Output() childFormsChanged = new EventEmitter<void>();
    @Output() sendExpectedValue = new EventEmitter<void>();
    @Output() validateSaveBtn = new EventEmitter<void>();
    @Input() employeeGroupData: EmployeeGroupPayload = null;
    @Input() contactGroupData: ContactGroupPayload = null;
    @Input() reportingSetJoinedFeedsList: ETLReportingSetJoinedFeedsList[] = null;
    @Input() feedName = "";
    @Input() modalClose = false;
    @Input() excludeIfSection: ETLExcludeIf;
    @Input() datesFieldNamesList: string[] = [];
    @Input() dataFieldNamesList: string[] = [];
    @Input() isedit: boolean;
    @Input() set selectedSection(data) {
        this._selectedSection = data;
        this.groupSelected = '';
        this.initializeFieldTypeOptions();
        if ((this._selectedSection === this.flowbuilderModules.EMPLOYEE_GROUP) || (this._selectedSection === this.flowbuilderModules.CONTACT_GROUP) || (this._selectedSection === this.flowbuilderModules.EXCLUDE_IF)) {
            this.dataFieldForm.get("name")?.disable();
            this.dataFieldForm.get("returnType")?.disable();
            this.hierarchyGroupClickedField = this.selectedItemHierarchyGroup;
        }
        else if (this._selectedSection === this.flowbuilderModules.DATES) {
            this.dataFieldForm.get("name")?.enable();
            this.dataFieldForm.get("returnType")?.disable();
            this.hierarchyGroupClickedField = '';
        }
        else {
            this.dataFieldForm.get("name")?.enable();
            this.dataFieldForm.get("returnType")?.enable();
            this.hierarchyGroupClickedField = '';
        }

        if (this._selectedSection === this.flowbuilderModules.EXCLUDE_IF) {
            this.hierarchyGroupClickedField = '';
            this.dataFieldForm.patchValue({
                name: 'ExcludeIf',
                returnType: {
                    id: ETLReportingSetReturnTypes.TRUE_FALSE,
                    label: this.getLocalizationString("True_False", "True/False"),
                }
            });
            this.dataFieldForm.get("returnType")?.enable();
        }
        this.employeeGroupChanges();
    }
    public _selectedSection: string;
    private employeeGroup: ETLGroup;
    dataFieldName: string;
    fieldExist = false;
    isReturnTypeChanged = false;
    public showConfigForms = true;
    public dataFieldNamePlaceholderText = "";
    public returnTypePlaceholderText = "";
    public fieldTypePlaceholderText = "";
    currentForm: any;
    uniqueId = 0;
    passDataToForms: any;
    previousForm: any;
    fieldTypeOptions: ETLReportingSetDropdownOptions[];
    returnTypeOptions: ETLReportingSetDropdownOptions[];
    public dataFieldForm: FormGroup;
    activeNestedFormIndex: number | null = null;
    outputForm: any;
    _initializedOutputForm: any;
    private returnTypeValue: any;
    public sendReturnType: ETLReportingSetDropdownOptions;
    protected readonly eReportingSetFieldTypes = ETLReportingSetFieldTypes;
    protected readonly flowbuilderModules = ETLReportingSetFlowbuilderModules;
    @Output() outputFormPayload = new EventEmitter();
    @Input() set defaultConfigurationData(data: any) {
        this._defaultConfigurationData = data;
        if (this.dataFieldForm && data.fieldName) {
            this.dataFieldForm.get("name").setValue(data.fieldName);
            this.dataFieldForm.get("returnType").setValue(data.returnDropdownOption);
        } else {
            this.initializeForm();
        }
    }
    public _defaultConfigurationData: DefaultConfigurationData | {} = {};
    @Input() empGrpSubject: Subject<EmployeeGroupPayload>;
    public hierarchyGroupClickedField = '';
    private previousSelection: string;
    private selectedItemHierarchyGroup: string;
    private groupSelected: string;
    // This is called when an existing item is clicked 
    @Input() set initializedOutputForm(data) {
        this._initializedOutputForm = data;
        this.setConfigureForm();
    }
    @Output() formValid = new EventEmitter<boolean>();
    @Output() formErrors = new EventEmitter<object>();
    @Input() set handleEmployeeGroup(employeeGroupData) {
        this.employeeGroup = employeeGroupData;
        this.employeeGroupChanges();
    }

    @Input() set handleContactGroup(contactGroupData: ETLGroup) {
        if (!this.isedit && contactGroupData) {
            this.groupSelected = contactGroupData.group;
            contactGroupData.selectedItem = contactGroupData.selectedItem.replace(/\s/g, '');
            if (this.groupSelected === this.flowbuilderModules.CONTACT_GROUP) {
                this.dataFieldForm.patchValue({
                    returnType: {
                        id: ETLReportingSetReturnTypes.WHOLE_NUMBER,
                        label: this.getLocalizationString("Whole_Number", "Whole Number"),
                    }
                });
                if (!contactGroupData?.contactSaveItem[HierarchyGroupName.COMPANY] && contactGroupData.selectedItem === HierarchyGroupName.COMPANY) {
                    const transformValue = this.getLocalizationString("Con_Company", "Concompany");
                    this.dataFieldForm.patchValue({ name: transformValue.toLocaleUpperCase() });
                    this.executeContactSetting();
                }
                else if (!contactGroupData?.contactSaveItem[HierarchyGroupName.CAMPAIGN] && contactGroupData.selectedItem === HierarchyGroupName.CAMPAIGN) {
                    const transformValue = this.getLocalizationString("Con_Campaign", "Concampaign");
                    this.dataFieldForm.patchValue({ name: transformValue.toLocaleUpperCase() });
                    this.executeContactSetting();
                }
                else if (!contactGroupData?.contactSaveItem[HierarchyGroupName.SKILL] && contactGroupData.selectedItem === HierarchyGroupName.SKILL) {
                    const transformValue = this.getLocalizationString("Con_Skill", "Conskill");
                    this.dataFieldForm.patchValue({ name: transformValue.toLocaleUpperCase() });
                    this.executeContactSetting();
                }
                else if (!contactGroupData?.contactSaveItem[HierarchyGroupName.POINT_OF_CONTACT] && contactGroupData.selectedItem === HierarchyGroupName.POINT_OF_CONTACT) {
                    const transformValue = this.getLocalizationString("Con_PointOfContact", "Conpointofcontact");
                    this.dataFieldForm.patchValue({ name: transformValue.toLocaleUpperCase() });
                    this.executeContactSetting();
                }
            }
        }
    }

    employeeGroupChanges(): void {
        if (!this.isedit && this._selectedSection === this.flowbuilderModules.EMPLOYEE_GROUP) {
            if (this.employeeGroup) {
                this.groupSelected = this.employeeGroup.group;
                this.dataFieldForm.controls['returnType'].setValue(
                    {
                        id: ETLReportingSetReturnTypes.WHOLE_NUMBER,
                        label: this.getLocalizationString("Whole_Number", "Whole Number"),
                    });
                if (!this.employeeGroup.saveItem[HierarchyGroupName.COMPANY] && this.employeeGroup.selectedItem === HierarchyGroupName.COMPANY) {
                    const transformValue = this.getLocalizationString("Emp_Company", "Empcompany");
                    this.dataFieldForm.controls['name'].setValue(transformValue.toLocaleUpperCase());
                    this.executeEmployeeSetting();
                }
                else if (!this.employeeGroup.saveItem[HierarchyGroupName.TEAM] && this.employeeGroup.selectedItem === HierarchyGroupName.TEAM) {
                    const transformValue = this.getLocalizationString("Emp_Teams", "Empteam");
                    this.dataFieldForm.controls['name'].setValue(transformValue.toLocaleUpperCase());
                    this.executeEmployeeSetting();
                }
                else if (!this.employeeGroup.saveItem[HierarchyGroupName.AGENT] && this.employeeGroup.selectedItem === HierarchyGroupName.AGENT) {
                    const transformValue = this.getLocalizationString("Emp_Agent", "Empagent");
                    this.dataFieldForm.controls['name'].setValue(transformValue.toLocaleUpperCase());
                    this.executeEmployeeSetting();
                }
            }
        }
    }

    @Input() set hierarchyGroupClickedItem(obj: any) {
        if (obj) {
            this.hierarchyGroupClickedField = obj.selectedItem;
            this.groupSelected = obj.group;
            this.selectedItemHierarchyGroup = this.hierarchyGroupClickedField;
        }
    }

    @ViewChild(CxoneReportingSetConditionalFieldComponent) conditionalComponent!: CxoneReportingSetConditionalFieldComponent;
    @ViewChild(CxoneReportingSetComplexNumericFieldComponent) complexNumericComponent!: CxoneReportingSetComplexNumericFieldComponent;

    constructor(
        private cvLocalizationService: CVLocalizationService,
        private fb: FormBuilder,
        private dialogSrvc: DialogService,
        private changeDetectorRef: ChangeDetectorRef
    ) {
        this.initializeForm();
    }

    get selectedSection() {
        return this._selectedSection;
    }

    get fieldType() {
        return this.dataFieldForm.get("fieldType").value;
    }

    get returnType() {
        return this.dataFieldForm.get("returnType").value;
    }

    get nestedDataFields() {
        return this.dataFieldForm.get("nestedDataFields") as FormArray;
    }

    get defaultConfigurationData() {
        return this._defaultConfigurationData;
    }

    public get thisFieldIsRequired() {
        return !this.dataFieldForm.get('name').value && !this.dataFieldForm.get('name').valid && this.dataFieldForm.get('name').touched && !this.charLimitReportDatafieldError && !this.forbiddenCharError;
    }

    public get charLimitReportDatafieldError() {
        return this.dataFieldForm.controls['name'].errors?.maxlength && !this.forbiddenCharError;
    }

    public get forbiddenCharError() {
        return this.dataFieldForm.controls['name'].errors?.forbiddenCharacters && !this.charLimitReportDatafieldError;
    }

    public forbiddenCharactersValidator(control: FormControl) {
        const forbidden = /[\^\/\\\!\+\<\>\?\#\&\@\"\,]/.test(control.value);
        return forbidden ? { forbiddenCharacters: { value: control.value } } : null;
    }

    private executeEmployeeSetting(): void {
        this.dataFieldForm.controls['fieldType'].setValue({
            id: ETLReportingSetFieldTypes.SIMPLE,
            label: ETLReportingSetFieldTypes.SIMPLE
        });
        this.initializeFieldTypeOptions();
        this.fieldTypeChanged({ selected: this.fieldTypeOptions[0] });
        this.formValid.emit(true);
    }

    private executeContactSetting(): void {
        this.dataFieldForm.controls['fieldType'].setValue({
            id: ETLReportingSetFieldTypes.SIMPLE,
            label: ETLReportingSetFieldTypes.SIMPLE
        });
        if (!this.fieldTypeOptions) {
            this.initializeFieldTypeOptions();
        }
        this.fieldTypeChanged({ selected: this.fieldTypeOptions[0] });
        this.formValid.emit(true);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.modalClose || (this.excludeIfSection && this.excludeIfSection.isAdd)) {
            this.resetDataFieldForm();
        }
        this.initializeFieldTypeOptions();
        this.initializeReturnTypeOptions();
        this.prepopulateDropdown();
    }

    initializeForm() {
        this.dataFieldForm = this.fb.group({
            name: new FormControl('', [Validators.required, Validators.maxLength(100), this.forbiddenCharactersValidator]),
            fieldType: new FormControl(),
            returnType: new FormControl("", Validators.required),
            nestedDataFields: new FormArray([]),
        });
    }

    async ngOnInit() {
        await this.loadLocalization();
        this.initializeFieldTypeOptions();
        this.initializeReturnTypeOptions();
    }

    prepopulateDropdown(): void {
        if (!this.outputForm && this._selectedSection && (this._selectedSection === "dates" || this._selectedSection === "dataFields")) {
            if (this._selectedSection === 'dates') {
                this.dataFieldForm.get("returnType").setValue(this.returnTypeOptions[ETLReportingSetReturnTypes.DATE]);
                this.returnTypeValue = this.dataFieldForm.get("returnType").value;
            } else if (this._selectedSection === 'dataFields') {
                this.dataFieldForm.get("returnType").setValue(this.returnTypeOptions[ETLReportingSetReturnTypes.TEXT]);
                this.returnTypeValue = this.dataFieldForm.get("returnType").value;
            }
            this.initializeFieldTypeOptions();
            this.dataFieldForm.get("name").setValue("");
            this.dataFieldForm.get("fieldType").setValue(this.fieldTypeOptions[0]);
            this.fieldTypeChanged({ selected: this.fieldTypeOptions[0] });
        }
        if (this.excludeIfSection && this.excludeIfSection.source === this.flowbuilderModules.EXCLUDE_IF) {
            this.handleExcludeIf();
        }
        this.sendReturnType = this.dataFieldForm.get("returnType").value;
    }

    handleExcludeIf() {
        this.initializeFieldTypeOptions();
        if (this.excludeIfSection.isAdd) {
            this.dataFieldForm.patchValue({
                name: 'ExcludeIf',
                returnType: {
                    id: ETLReportingSetReturnTypes.TRUE_FALSE,
                    label: this.getLocalizationString("True_False", "True/False"),
                }
            });
            this.dataFieldForm.controls['fieldType'].setValue({
                id: ETLReportingSetFieldTypes.SIMPLE,
                label: ETLReportingSetFieldTypes.SIMPLE
            });
            this.fieldTypeChanged({ selected: this.fieldTypeOptions[0] });
            if (!!this.outputForm?.name) this.formValid.emit(!!this.outputForm?.name);
        }
    }

    resetDataFieldForm() {
        this.outputForm = null;
        this.uniqueId = 0;
        this.hideFields = false;
        this.groupSelected = '';
        this.currentForm = null;
    }

    setConfigureForm() {
        if (this._initializedOutputForm) {
            this.outputForm = this._initializedOutputForm;
            this.currentForm = this._initializedOutputForm;
            this.passDataToForms = this._initializedOutputForm['child'];
            this.dataFieldForm.controls["fieldType"].setValue(this.outputForm?.fieldType);
            this.dataFieldForm.controls["name"].setValue(this.outputForm?.name);
            this.dataFieldForm.controls["returnType"].setValue(this.outputForm?.returnType);
            this.getLastUniqueID(this.outputForm);
            this.hideFields = false;
            this.emitBuildedForm();
            if (!!this.outputForm?.name) this.formValid.emit(!!this.outputForm?.name);
            this.validateSimpleFieldName();
        }
        this.fieldExist = false;

        this.dataFieldForm.valueChanges.subscribe(() => {
            if (this.dataFieldForm.dirty)
                sendMessageCXOne({ hasNonSavedChanges: true });
        });
    }

    validateSimpleFieldName() {
        const formData = this.passDataToForms;
        if (formData.type === ETLReportingSetFieldTypes.CONDITIONAL) {
            const conditionalParams = ['positive', 'negative', 'comparisons'];
            conditionalParams.forEach(param => {
                if (param != ETLReportingSetFieldTypes.COMPARISONS) {
                    formData[param].map(item => {
                        if (item.type === ETLReportingSetFieldTypes.SIMPLE) {
                            this.setSimpleFieldName(item);
                        }
                    });
                } else {
                    formData[param].map(item => {
                        if (item?.field1?.length > 0 && item?.field1[0].type === ETLReportingSetFieldTypes.SIMPLE) {
                            this.setSimpleFieldName(item?.field1[0]);
                        }
                        if (item?.field2?.length > 0 && item?.field2[0].type === ETLReportingSetFieldTypes.SIMPLE) {
                            this.setSimpleFieldName(item?.field2[0]); ''
                        }
                    });
                }
            })
        } else if (formData.type === ETLReportingSetFieldTypes.COMPLEX_NUMERIC_STRING) {
            formData.formulas.forEach(element => {
                if (element.numericType === "expression" && element.childs.length > 0) {
                    element?.childs.forEach(item => {
                        if (item.type === ETLReportingSetFieldTypes.SIMPLE) {
                            this.setSimpleFieldName(item);
                        }
                    });
                }
            });
        } else if (formData.type === ETLReportingSetFieldTypes.COMPLEX_DATE_STRING) {
            const fieldsToCheck = ['rightOperand', 'leftOperand', 'months', 'days', 'hours', 'minutes', 'seconds'];
            fieldsToCheck.forEach(param => {
                if (formData.hasOwnProperty(param)) {
                    formData[param].map(item => {
                        if (item.type === ETLReportingSetFieldTypes.SIMPLE) {
                            this.setSimpleFieldName(item);
                        }
                    });
                }
            })
        }
        else {
            formData?.childs.forEach(item => {
                if (item.type === ETLReportingSetFieldTypes.SIMPLE) {
                    this.setSimpleFieldName(item);
                }
            });
        }
    }

    setSimpleFieldName(item: any) {
        if (item.simpleFieldType.return?.id === 1) {
            const simpleName = item.simpleFieldType?.Field?.Name || ETLReportingSetFieldTypes.SIMPLE;
            item.nameForTree = simpleName;
            item.name = simpleName != 'Simple' ? "Simple:[" + simpleName + "]" : simpleName;
        } else {
            const simpleName = (item.simpleFieldType?.DefaultValue !== 'null' && item.simpleFieldType?.DefaultValue !== "Invalid Date") ? '"' + item.simpleFieldType?.DefaultValue + '"' : 'Simple';
            item.nameForTree = simpleName;
            if (item.simpleFieldType?.Field?.Name && item.simpleFieldType.return.id === ETLReportingSetSimpleFieldReturnOptions.SPECIFIC_FIELD_AND_DEFAULT_VALUE) {
                item.name = "Simple:[" + item.simpleFieldType?.Field?.Name + "]" + " Or " + simpleName;
            } else {
                item.name = "Simple:" + simpleName;
            }
        }
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection("ETL_Reporting_Set");
        } catch (error) {
            console.log("Failed to load localization for ETL_Reporting_Set", error);
        } finally {
            this.dataFieldNamePlaceholderText = this.getLocalizationString("Enter_Data_Field_Name", "Enter Data Field Name");
            this.fieldTypePlaceholderText = this.getLocalizationString("Select_Field_Type", "Select Field Type");
            this.returnTypePlaceholderText = this.getLocalizationString("Select_Return_Type", "Select Return Type");
        }
    }

    public getLocalizationString(key: string, defaultValue: string): string {
        return this.cvLocalizationService.getCachedText("ETL_Reporting_Set", key, defaultValue);
    }

    public addNestedDataField() {
        const nestedFormsArray = this.nestedDataFields;
        nestedFormsArray.push(
            this.fb.group({
                name: new FormControl(""),
                fieldType: new FormControl(),
                returnType: new FormControl(),
                nestedDataFields: new FormArray([]),
            })
        );
        this.activeNestedFormIndex = nestedFormsArray.length - 1;
    }

    public initializeFieldTypeOptions(): void {
        const fieldTypeOptions = [
            {
                id: ETLReportingSetFieldTypes.SIMPLE,
                label: this.getLocalizationString("Simple", "Simple"),
                orderId: ETLReportingSetFieldTypesId.SIMPLE,
                permissions: [0, 1, 2, 3, 4]
            },
            {
                id: ETLReportingSetFieldTypes.CONDITIONAL,
                label: this.getLocalizationString("Conditional", "Conditional"),
                orderId: ETLReportingSetFieldTypesId.CONDITIONAL,
                permissions: [0, 1, 2, 3, 4]
            },
            {
                id: ETLReportingSetFieldTypes.COMPLEX_STRING,
                label: this.getLocalizationString("Complex_String", "Complex String"),
                type: "ComplexString",
                orderId: ETLReportingSetFieldTypesId.COMPLEX_STRING,
                permissions: [0]
            },
            {
                id: ETLReportingSetFieldTypes.SUBSTRING,
                label: this.getLocalizationString("Substring", "Substring"),
                orderId: ETLReportingSetFieldTypesId.SUBSTRING,
                permissions: [0]
            },
            {
                id: ETLReportingSetFieldTypes.COMPLEX_DATE,
                label: this.getLocalizationString("Complex_Date", "Complex Date"),
                orderId: ETLReportingSetFieldTypesId.COMPLEX_DATE,
                permissions: [2, 3]
            },
            {
                id: ETLReportingSetFieldTypes.COMPLEX_NUMERIC,
                label: this.getLocalizationString("Complex_Numeric", "Complex Numeric"),
                type: "ComplexNumeric",
                orderId: ETLReportingSetFieldTypesId.COMPLEX_NUMERIC,
                permissions: [2]
            },
            {
                id: ETLReportingSetFieldTypes.REGEX,
                label: this.getLocalizationString("Regular_Expression", "Regular Expression"),
                orderId: ETLReportingSetFieldTypesId.REGEX,
                permissions: [4]
            },
            {
                id: ETLReportingSetFieldTypes.COALESCE,
                label: this.getLocalizationString("Coalesce", "Coalesce"),
                orderId: ETLReportingSetFieldTypesId.COALESCE,
                permissions: [0, 1, 2, 3, 4]
            },
        ];
        const returnTypeObj = this.dataFieldForm.controls["returnType"].value;
        this.fieldTypeOptions = [];
        if (returnTypeObj.hasOwnProperty('id')) {
            fieldTypeOptions.forEach(item => {
                if (item.permissions.includes(returnTypeObj.id)) {
                    this.fieldTypeOptions.push(item);
                }
            })
        }
        this.previousSelection = returnTypeObj.label;
    }

    public initializeReturnTypeOptions(): void {
        this.returnTypeOptions = [
            {
                id: ETLReportingSetReturnTypes.TEXT,
                label: this.getLocalizationString("Text", "Text"),
            },
            {
                id: ETLReportingSetReturnTypes.WHOLE_NUMBER,
                label: this.getLocalizationString("Whole_Number", "Whole Number"),
            },
            {
                id: ETLReportingSetReturnTypes.DECIMAL_NUMBER,
                label: this.getLocalizationString("Decimal_Number", "Decimal Number"),
            },
            {
                id: ETLReportingSetReturnTypes.DATE,
                label: this.getLocalizationString("Date", "Date"),
            },
            {
                id: ETLReportingSetReturnTypes.TRUE_FALSE,
                label: this.getLocalizationString("True_False", "True/False"),
            },
        ];
    }

    asFormGroup(control: AbstractControl): FormGroup {
        return control as FormGroup;
    }

    returnTypeChanged(event: any): void {
        if (event.selected.label === this.previousSelection) {
            return;
        }
        this.changeDetectorRef.detectChanges();
        this.sendReturnType = event.selected;
        this.showReturnTypeAlertModal(event.selected);
        this.previousSelection = event.selected.label;
    }

    fieldTypeChanged(event: any) {
        const selectedId = event.selected.id.replace(/ /g, "");
        if (this.currentForm && this.passDataToForms && this.currentForm.hasOwnProperty('isNew') && this.currentForm.isNew == false) {
            this.passDataToForms.type = selectedId;
            this.passDataToForms.name = event.selected.id;
            this.passDataToForms.childs = [];
            this.passDataToForms.uniqueId = this.passDataToForms.uniqueId;
            this.passDataToForms.parentId = this.passDataToForms.parentId;
            this.passDataToForms.fieldType = event.selected;
            this.passDataToForms.isNew = true;
            const keys = ['type', 'name', 'childs', 'uniqueId', 'parentId', 'fieldType', 'isNew'];
            for (let key in this.passDataToForms) {
                if (!keys.includes(key)) {
                    delete this.passDataToForms[key];
                }
            }
            this.currentForm.isNew = true;
            if (this.currentForm.hasOwnProperty('child') || this.currentForm.parentId === 0) {
                this.outputForm.fieldType = event.selected;
            }
        } else {
            if (!this.outputForm) {
                this.uniqueId = 0;
                this.outputForm = {
                    ...this.dataFieldForm.getRawValue(),
                    ...{ uniqueId: this.uniqueId },
                };
                this.uniqueId = this.uniqueId + 1;
                this.outputForm["child"] = {
                    type: selectedId,
                    name: event.selected.id,
                    uniqueId: this.uniqueId,
                    parentId: this.outputForm.uniqueId,
                    childs: [],
                    fieldType: event.selected,
                    isNew: true
                };
                this.passDataToForms = this.outputForm["child"];
                this.currentForm = this.outputForm;
                this.previousForm = this.currentForm;
            } else if (this.currentForm?.type === "ComplexDate") {
                let outputForm: any = {};
                this.uniqueId = this.uniqueId + 1;
                outputForm = {
                    type: selectedId,
                    name: event.selected.id,
                    childs: [],
                    uniqueId: this.uniqueId,
                    parentId: this.currentForm.uniqueId,
                    fieldType: event.selected,
                    isNew: true
                };
                this.currentForm[this.currentForm?.operand].push(outputForm);
                this.passDataToForms = outputForm;
                this.previousForm = this.currentForm;
            } else if (this.currentForm?.type === "Conditional") {
                if (this.currentForm?.operand !== 'field1' && this.currentForm?.operand !== 'field2') {
                    let outputForm: any = {};
                    this.uniqueId = this.uniqueId + 1;
                    outputForm = {
                        type: selectedId,
                        name: event.selected.id,
                        childs: [],
                        uniqueId: this.uniqueId,
                        parentId: this.currentForm.uniqueId,
                        fieldType: event.selected,
                        isNew: true
                    };
                    this.currentForm[this.currentForm?.operand].push(outputForm);
                    this.passDataToForms = outputForm;
                    this.previousForm = this.currentForm;
                } else {
                    let currentUniqueId = this.currentForm.uniqueId;
                    let outputForm: any = {};
                    this.uniqueId = this.uniqueId + 1;
                    outputForm = {
                        type: selectedId,
                        name: event.selected.id,
                        childs: [],
                        uniqueId: this.uniqueId,
                        parentId: currentUniqueId,
                        fieldType: event.selected,
                        isNew: true
                    };
                    this.currentForm.comparisonForm[this.currentForm?.operand].push(outputForm);
                    this.passDataToForms = outputForm;
                    this.previousForm = this.currentForm;
                }
            }
            else if (this.currentForm.hasOwnProperty('child')) {
                this.uniqueId = 1;
                this.outputForm["child"] = {
                    type: selectedId,
                    name: event.selected.id,
                    uniqueId: 1,
                    parentId: 0,
                    childs: [],
                    fieldType: event.selected,
                    isNew: true
                };
                this.passDataToForms = this.outputForm["child"];
            }
            else {
                let outputForm: any = {};
                this.uniqueId = this.uniqueId + 1;
                let currentUniqueId = this.currentForm.uniqueId;
                if (this.currentForm.numericUniqueId) {
                    currentUniqueId = this.currentForm.numericUniqueId;
                }
                if (!this.currentForm.hasOwnProperty("child")) {
                    outputForm = {
                        type: selectedId,
                        name: event.selected.id,
                        childs: [],
                        uniqueId: this.uniqueId,
                        parentId: currentUniqueId,
                        fieldType: event.selected,
                        isNew: true
                    };
                    this.currentForm.childs.push(outputForm);
                    this.passDataToForms = this.currentForm.childs[this.currentForm.childs.length - 1];
                    this.previousForm = this.currentForm;
                }
            }
        }
        this.currentForm.isNew = false;
        this.outputFormPayload.emit(this.outputForm);
        this.changeDetectorRef.detectChanges();
        this.emitBuildedForm();
        if (event.selected?.id) {
            this.hideFields = true;
        }
    }

    goBack(parentUniqueId = null) {
        this.showConfigForms = false;
        let parentId = parentUniqueId === null ? this.passDataToForms.parentId : parentUniqueId;
        this.currentForm = this.findNodeById(this.outputForm, parentId);
        if (parseInt(this.currentForm.uniqueId) === 0 || parseInt(this.currentForm.uniqueId) === 1) {
            this.dataFieldForm.controls["fieldType"].setValue(this.outputForm?.child?.fieldType);
            this.hideFields = false;
        } else {
            this.dataFieldForm.controls["fieldType"].setValue(this.currentForm?.fieldType);
            this.hideFields = true;
        }
        if (parentUniqueId === 0) {
            this.passDataToForms = this.currentForm['child'];
        } else {
            let comparisonItem = {};
            if (this.currentForm.type === "Conditional" && this.currentForm.hasOwnProperty('comparisons') && parentUniqueId === null) {
                for (let a = 0; a < this.currentForm.comparisons.length; a++) {
                    const compareItem = this.currentForm.comparisons[a];
                    if (compareItem.field1.length > 0 && compareItem?.field1[0].uniqueId === this.passDataToForms.uniqueId) {
                        comparisonItem = {
                            compareIndex: a,
                            compareItem: compareItem
                        };
                    }
                    if (compareItem.field2.length > 0 && compareItem?.field2[0].uniqueId === this.passDataToForms.uniqueId) {
                        comparisonItem = {
                            compareIndex: a,
                            compareItem: compareItem
                        };
                    }
                }
            }
            let formulaItems = {}
            if (this.currentForm.type === "ComplexNumeric" && this.currentForm.hasOwnProperty('formulas') && parentUniqueId === null) {
                for (let a = 0; a < this.currentForm.formulas.length; a++) {
                    const formulaItem = this.currentForm.formulas[a];
                    if (formulaItem.childs.length > 0 && formulaItem.childs[0].uniqueId === this.passDataToForms.uniqueId) {
                        formulaItems = {
                            formulaIndex: a,
                            formulaItem: formulaItem
                        };
                    }
                }
            }
            this.passDataToForms = this.currentForm;
            this.currentForm.isNew = false;
            setTimeout(() => {
                this.showConfigForms = true;
            }, 0);
            if (comparisonItem.hasOwnProperty('compareIndex')) {
                setTimeout(() => {
                    if (this.conditionalComponent) {
                        this.conditionalComponent.editExistFromDataField(comparisonItem['compareItem']);
                    }
                }, 0);
            }
            if (formulaItems.hasOwnProperty('formulaIndex')) {
                setTimeout(() => {
                    if (this.complexNumericComponent) {
                        this.complexNumericComponent.editFormula(formulaItems['formulaItem']);
                    }
                }, 0);
            }
        }
    }

    findNodeById(data, uniqueId) {
        if (data) {
            if (data?.uniqueId === uniqueId) {
                return data;
            }
            let fieldsToCheck = [];
            switch (data?.type) {
                case 'ComplexNumeric':
                    fieldsToCheck = data.formulas ? ['formulas'] : [];
                    break;
                case 'ComplexDate':
                    fieldsToCheck = ['rightOperand', 'leftOperand', 'months', 'days', 'hours', 'minutes', 'seconds'];
                    break;
                case 'Conditional':
                    fieldsToCheck = ['comparisons', 'positive', 'negative'];
                    break;
                default:
                    fieldsToCheck = data.childs ? ['childs'] : ['child'];
            }
            for (let field of fieldsToCheck) {
                if (data[field]) {
                    if (field === "comparisons") {
                        let node;
                        for (let a = 0; a < data[field].length; a++) {
                            const element = data[field][a];
                            if (element?.field1?.length > 0) {
                                node = this.findNodeById(element?.field1[0], uniqueId);
                                if (node) {
                                    break;
                                }
                            }
                            if (element?.field2?.length > 0) {
                                node = this.findNodeById(element?.field2[0], uniqueId);
                                if (node) {
                                    break;
                                }
                            }
                        };
                        if (node) {
                            return node;
                        }
                    }
                    let found = Array.isArray(data[field]) ? this.findInArray(data[field], uniqueId) : this.findNodeById(data[field], uniqueId);
                    if (found) {
                        return found;
                    }
                    if (data.type === 'ComplexNumeric' && data.formulas) {
                        for (let i = 0; i < data.formulas.length; i++) {
                            let found = this.findNodeById(data.formulas[i], uniqueId);
                            if (found) return found;
                        }
                    }
                }
            }
            return null;
        } else {
            return null;
        }
    }

    findInArray(array, uniqueId) {
        for (let item of array) {
            let found = this.findNodeById(item, uniqueId);
            if (found) {
                return found;
            }
        }
        return null;
    }

    nextClick() {
        this.hideFields = true;
        this.passDataToForms = this.outputForm.child;
        this.previousForm = this.outputForm.child;
        this.currentForm = this.outputForm.child;
    }

    complextStringEdit(item) {
        if (item.hasOwnProperty('fieldType')) {
            this.dataFieldForm.controls["fieldType"].setValue(item.fieldType);
        } else {
            this.dataFieldForm.controls["fieldType"].setValue({
                ...{ type: item.type, id: item.name, label: item.name },
            });
        }
        this.dataFieldForm.controls["fieldType"].updateValueAndValidity();
        this.passDataToForms = item;
        this.previousForm = item;
        this.currentForm = item;
        this.currentForm.isNew = false;
    }

    getPrevForm(data, prevUniqueId) {
        let findItem: any;
        if (data?.type === "ComplexDate") {
            const childsList = ["seconds", "months", "rightOperand", "minutes", "hours",
                "leftOperand", "hours", "childs", "days", "field1", "field2", "negative", "positive", "formulas"
            ];
            childsList.forEach(childItem => {
                if (findItem === undefined) {
                    findItem = data[childItem].find(
                        (item) => item.uniqueId === prevUniqueId
                    );
                } else { return; }
            });
        } else {
            findItem = data.childs.find(
                (item) => item.uniqueId === prevUniqueId
            );

        }
        if (findItem) {
            this.previousForm = findItem;
            this.passDataToForms = findItem;
            this.currentForm = findItem;
        } else {
            data.childs.forEach((element) => {
                this.getPrevForm(element, prevUniqueId);
            });
        }
    }

    handleComplexString(ev: any, type) {
        this.dataFieldForm.controls["fieldType"].setValue('');
        this.currentForm = ev;
        this.currentForm.isNew = true;
    }

    public getLastUniqueID(parentData) {
        let MAX_UNIQUE_ID = this.uniqueId;
        const { child } = parentData;

        if (child.uniqueId > MAX_UNIQUE_ID) {
            MAX_UNIQUE_ID = child.uniqueId;
        }
        const { childs } = child;
        this.getMaxUniqueId(childs);
    }

    private getMaxUniqueId(childs) {
        let MAX_UNIQUE_ID = this.uniqueId;
        childs.forEach((child) => {
            if (child.uniqueId > MAX_UNIQUE_ID) {
                MAX_UNIQUE_ID = child.uniqueId;
            }
            this.uniqueId = MAX_UNIQUE_ID;
            if (child?.childs?.length > 0) {
                this.getMaxUniqueId(child.childs);
            } else {
                const fieldsToCheck = DataFlowSubFields;
                fieldsToCheck.forEach(field => {
                    if (field === 'comparisons' && child.hasOwnProperty(field)) {
                        for (let i = 0; i < child[field].length; i++) {
                            const element = child[field][i];
                            if (element?.field1?.length > 0) {
                                this.getMaxUniqueId(element?.field1);
                            }
                            if (element?.field2?.length > 0) {
                                this.getMaxUniqueId(element?.field2);
                            }
                        }
                    } else if (child.hasOwnProperty(field) && child[field].length > 0) {
                        this.getMaxUniqueId(child[field]);
                    }
                });
            }
        });
    }

    public showReturnTypeAlertModal(selectedItem: ETLReportingSetDropdownOptions): void {
        const dialogData = {
            title: this.getLocalizationString("Cancel_Returntype", "Change Return Type?"),
            type: "user-warning",
            message: `<div class="msg-line-1" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Returntype_Modal_Lost_Changes"> Changing return type will resets values. </div>`,
            primaryButtonText: this.getLocalizationString("Continue", "Continue"),
            closeButtonText: this.getLocalizationString("Cancel", "Cancel"),
        };

        const ref = this.dialogSrvc.open(MessageModalComponent, {
            width: "420px",
            height: "184px",
            styleClass: "cx-one-ui modal-center testing",
            data: dialogData,
        });

        ref.onClose.subscribe((isBack: boolean) => {
            if (isBack && this.outputForm) {
                this.outputForm = null;
                this.passDataToForms = null;
                this.isReturnTypeChanged = true;
                this.dataFieldForm.get("fieldType").setValue(this.fieldTypeOptions[0]);
                this.sendReturnType = selectedItem;
                this.fieldTypeChanged({ selected: this.fieldTypeOptions[0] });
            } else if (isBack) {
                this.dataFieldForm.get('returnType').patchValue(this.dataFieldForm.get('returnType').value);
            }
            else if (!isBack) {
                if (this.outputForm) {
                    this.dataFieldForm.get('returnType').patchValue(this.outputForm.returnType);
                    this.sendReturnType = this.outputForm.returnType;
                } else {
                    this.dataFieldForm.get('returnType').patchValue(this.returnTypeValue);
                    this.sendReturnType = this.returnTypeValue;
                }
            }
            this.initializeFieldTypeOptions();
        });
    }

    emitBuildedForm() {
        if (this.outputForm) {
            this.outputForm.name = this.dataFieldForm.getRawValue().name === "" ? 'undefined' : this.dataFieldForm.getRawValue().name;
        }
        this.buildedForm.emit(this.outputForm || this.dataFieldForm.value);
    }

    formChanged(item) {
        this.dataFieldForm.markAsDirty();
        this.childFormsChanged.emit(item);
    }

    formNotChanged(item) {
        this.dataFieldForm.markAsPristine();
        this.childFormsChanged.emit(item);
    }

    nameChanges(inputText) {
        if (this.outputForm) {
            this.outputForm.name = this.dataFieldForm.getRawValue().name === "" ? 'undefined' : this.dataFieldForm.getRawValue().name;
            this.childFormsChanged.emit(this.outputForm);
        }

        let inputVal = inputText.modelValue.toUpperCase().trim();
        this.datesFieldNamesList = this.datesFieldNamesList.map(item => item.toUpperCase());
        this.dataFieldNamesList = this.dataFieldNamesList.map(item => item.toUpperCase());

        let fieldNamesList = null;
        if (this._selectedSection === this.flowbuilderModules.DATES) {
            fieldNamesList = this.datesFieldNamesList;
        } else if (this._selectedSection === this.flowbuilderModules.DATA_FIELDS) {
            fieldNamesList = this.dataFieldNamesList;
        }
        this.fieldExist = fieldNamesList ? fieldNamesList.includes(inputVal) : false;
        this.formErrors.emit({ isNameExist: this.fieldExist, isNameError: this.dataFieldForm.get('name').invalid });
    }

    emitBtnStateToFlowBuilder(event: any) {
        this.validateSaveBtn.emit(event);
    }
}
